module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 26 25"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('rect', {
    attrs: {
      "width": "24",
      "height": "21",
      "x": "1",
      "y": "3",
      "stroke": _vm.style,
      "stroke-width": "2",
      "rx": "3"
    }
  }), _c('path', {
    attrs: {
      "fill": _vm.style,
      "d": "M1 7h24v2H1zM4 0h2v6H4zM20 0h2v6h-2zM6.5 19v2.5H4V19h2.5zm3.88 0v2.5h-2.5V19h2.5zm3.87 0v2.5h-2.5V19h2.5zm3.88 0v2.5h-2.5V19h2.5zM6.5 15v2.5H4V15h2.5zm3.88 0v2.5h-2.5V15h2.5zm3.87 0v2.5h-2.5V15h2.5zm3.88 0v2.5h-2.5V15h2.5zM22 15v2.5h-2.5V15H22zM6.5 11v2.5H4V11h2.5zm3.88 0v2.5h-2.5V11h2.5zm3.87 0v2.5h-2.5V11h2.5zm3.88 0v2.5h-2.5V11h2.5zM22 11v2.5h-2.5V11H22z"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61d2fc6d","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/remote-edu/calendar/components/selector/components/icons/CalendarIcon.vue
// module id = 55290f7923d9f48e02d3
// module chunks = 7